export const generateAdaptiveContent = ({
  className,
  description,
  limit,
  expanded,
  component
}) => {
  if (expanded) {
    return `${description}${component}`
  }

  const cleanText = description.replace(/<\/?[^>]+(>|$)/g, '')
  if (cleanText.length > limit) {
    return `<p ${!className ? '' : `class="${className}"`}>${cleanText.slice(0, limit)}${component}</p>`
  }

  return description
}

export const generateContentLimit = (largeDescription) => largeDescription ? 700 : 190
